export default __webpack_public_path__ + "static/media/no-screen.c9040b4b.svg";